import { find } from "linkifyjs";
import { InputRule } from "prosemirror-inputrules";
import { allowedProtocols, normalizeLink } from "./utils";
class LinkifyRegexMock {
    exec(str) {
        if (!str.endsWith(" ")) {
            return null;
        }
        const chunks = str.split(" ");
        const lastChunk = chunks[chunks.length - 2];
        const links = find(lastChunk);
        if (!links.length) {
            return null;
        }
        const lastLink = links[links.length - 1];
        const protocol = allowedProtocols.find((proto) => lastLink.href.startsWith(proto)) ||
            "http";
        const match = {
            schema: protocol,
            index: 0,
            lastIndex: lastChunk.length,
            raw: lastChunk,
            text: lastChunk,
            url: lastLink.href,
            length: lastChunk.length,
        };
        return [match];
    }
}
function UrlInputHandler(state, match, start, end) {
    const link = match[0];
    const adjustedStart = end - link.length;
    const hasMark = state.doc.rangeHasMark(adjustedStart, end, state.schema.marks.link);
    if (hasMark) {
        return null;
    }
    const mark = state.schema.mark("link", { href: normalizeLink(link.url) });
    const tr = state.tr.addMark(adjustedStart, end, mark).insertText(" ");
    return tr;
}
export const UrlInputRule = new InputRule(new LinkifyRegexMock(), UrlInputHandler);
